import Move from "./Move";



const Control = {
    current: 'items',
    previous: "",
    set_current: function (current) {

        if (this.current != current)
            this.previous = this.current;

        this.current = current;

    },
    set_previous: function () {
        this.current = this.previous;

    },
    items: {

        up: function () {
            Move.move_up(-1)
        },
        down: function () {
            Move.move_down(1)
        },
        ok: function () {
            Move.close_move()
        },
        back: function () {
            Move.close_move()
        },
        move: function () {
            // move
        }
    }
}



export default Control;